import service from '@/middleware'

const gpsApi = {
    /**
     * Datos paginados para el ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     */
    async findAll(pageSize, pageNumber, headers) {
        const url = pageSize != null && pageNumber != null
            ? `/api/gps/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/gps/all?headers=${headers}`
        const response = await service.http.get(url)
        return response
    },
    /**
     * Cantidad de documentos para el paginador del ABM
     */
    async getTotal () {
        const response = await service.http.get(`/api/gps/total`)
        return response
    },
    /**
     * Historial de un gps
     * @param {*} id
     */
    async getHistory(id, headers) {
        const response = await service.http.get(`/api/gps/history/${id}?headers=${headers}`)
        return response
    },
    /**
     * Estados
     */
    async getStates () {
        const response = await service.http.get(`/api/gps/states`)
        return response
    },
    /**
     * Validar la unicidad del unitId
     * @param {*} unitId
     */
    async validateUnitId (unitId) {
        const response = await service.http.get(`/api/gps/validate-unitId/${unitId}`)
        return response
    },
    /**
     * Crear nuevo gps
     * @param {*} gps
     */
    async create (gps) {
        const response = await service.http.post(`/api/gps/create`, gps)
        return response
    },
    /**
     * Actualizar gps
     * @param {*} gps 
     */
    async update (gps) {
        const response = await service.http.put(`/api/gps/update`, gps)
        return response
    },
    /**
     * Eliminar un gps
     * @param {*} id
     */
    async deleteOne (id) {
        const response = await service.http.delete(`/api/gps/${id}`)
        return response
    },
    /**
     * Eliminación múltiple
     * @param {*} ids
     */
    async deleteMany (ids) {
        const response = await service.http.put(`/api/gps/multiple-delete`, ids)
        return response
    },
    /**
     * Marcas
     */
    async getBrands(){
        const response = await service.http.get(`/api/gps/brands`)
        return response
    },
    /**
     * Modelos según marca
     * @param {*} brandId
     */
    async getModels(brandId){
        const response = await service.http.get(`/api/gps/models/${brandId}`)
        return response
    },
    /**
     * Obtener gps para el selector
     */
    async getAllForSelectorThingAbm() {
        const response = service.http.get(`/api/gps/all-for-selector-thing-abm`)
        return response
    },
    /**
     * Obtener información de un gps para el ABM de equipos
     */
    async getForThingABM(gpsId) {
        const response = service.http.get(`/api/gps/thing-abm-data/${gpsId}`)
        return response
    },
    /**
     * Obtener todos los modulos de comunicacion
     */
    async getcommunicationModules() {
        const result = await service.http.get(`/api/gps/comunication-module-get-all`)
        return result
    },
}

export default gpsApi
